import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationLevel } from 'src/app/@core/domain/enums/notification-type.enum';
import { FacilitySummary } from 'src/app/@core/domain/interfaces/facility-summary.interface';
import { StatusPageService } from '../../../services/status-page.service';

@Component({
  selector: 'app-facility-extended',
  templateUrl: './facility-extended.component.html',
  styleUrls: ['./facility-extended.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacilityExtendedComponent {
  @Input()
  facilitySummary!: FacilitySummary;

  @Input()
  alertClass = 'custom-icon__facility';

  @Input()
  statusType!: string;

  selection: string;

  constructor(private router: Router, private statusPageService: StatusPageService) {
    this.selection = 'notificationsForFacility';
  }

  public gotoFacilityDetails(id: number): void {
    this.router.navigate(['/status/facilities/', id], { skipLocationChange: true }).then((e) => {
      if (e) {
      } else {
      }
    });
  }

  alarmGoing(): boolean {
    let going = false;
    this.facilitySummary.emergencyAlarms.forEach((ea) => {
      if (ea.going) {
        going = true;
      }
    });
    return going;
  }

  alarmFromNotificationGoing(): boolean {
    let going = false;
    this.facilitySummary.notificationCounts.forEach((nc) => {
      if (
        (nc.level === NotificationLevel.Error || nc.level === NotificationLevel.Alarm) &&
        nc.count > 0
      ) {
        going = true;
      }
    });
    return going;
  }

  notificationCounts() {
    return this.statusPageService.formatNotificationTooltip(this.facilitySummary, this.statusType);
  }
}
